export default __webpack_public_path__ + "static/plainwax-1fdd18937e7d23ba0563413d7a956e31.png";